(() => {
  if (window.szykOptionalGift) return;
  window.szykOptionalGift = true;
  const giftId = 61053927817550;
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let busy = false;
  const isGift = item => Number(item.variant_id || item.id) === giftId;
  const hasPaid = cart => cart.items.some(item => !isGift(item) && item.quantity > 0 && item.original_price > 0);
  const gifts = cart => cart.items.filter(isGift);
  const enqueue = task => (queue = queue.then(task, task));
  const request = async (path, body) => {
    const options = {headers: {'Accept': 'application/json'}, credentials: 'same-origin', cache: 'no-store'};
    if (body) {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections}}));
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({...body, sections: [...new Set(sections)].slice(0, 5), sections_url: window.location.pathname});
    }
    const response = await fetch(root + path, options);
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Cart request failed');
    return result;
  };
  const publish = (cart, baseEvent = 'line-item:change') => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {cart, baseEvent, szykGift: true}}));
  };
  const render = cart => {
    const eligible = hasPaid(cart);
    const present = gifts(cart).length > 0;
    document.querySelectorAll('[data-szyk-gift]').forEach(offer => {
      offer.querySelectorAll('[data-szyk-gift-add]').forEach(button => {
        button.disabled = busy || !eligible || present;
        button.textContent = busy ? offer.dataset.loading : present ? offer.dataset.added : offer.dataset.add;
      });
      const status = offer.querySelector('[role="status"]');
      if (status) status.textContent = present ? offer.dataset.added : eligible ? '' : offer.dataset.required;
    });
  };
  const normalize = async cart => {
    const lines = gifts(cart);
    const updates = {};
    if (!hasPaid(cart)) {
      lines.forEach(item => updates[item.key] = 0);
    } else {
      let chosenGiftKept = false;
      lines.forEach(item => {
        const chosen = item.properties?._szyk_optional_gift === 'true';
        const quantity = chosen && !chosenGiftKept ? 1 : 0;
        if (quantity === 1) chosenGiftKept = true;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
    }
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      publish(cart);
    }
    render(cart);
    return cart;
  };
  const refresh = () => enqueue(async () => normalize(await request('cart.js'))).catch(() => {});
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-szyk-gift-add]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    const offer = button.closest('[data-szyk-gift]');
    busy = true;
    button.disabled = true;
    button.textContent = offer.dataset.loading;
    enqueue(async () => {
      try {
        let cart = await request('cart.js');
        if (!hasPaid(cart) || gifts(cart).length) {
          busy = false;
          await normalize(cart);
          return;
        }
        const added = await request('cart/add.js', {items: [{id: giftId, quantity: 1, properties: {_szyk_optional_gift: 'true'}}]});
        cart = await request('cart.js');
        cart.sections = added.sections;
        busy = false;
        cart = await normalize(cart);
        publish(cart, 'variant:add');
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', {bubbles: true, detail: {cart, items: added.items || [added]}}));
        const popup = offer.querySelector('dialog[open]');
        if (popup) popup.close();
      } catch (error) {
        busy = false;
        button.disabled = false;
        button.textContent = offer.dataset.add;
        offer.querySelector('[role="status"]').textContent = offer.dataset.error;
      }
    });
  });
  document.addEventListener('cart:change', event => { if (!event.detail?.szykGift) refresh(); });
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  refresh();
})();
